module.exports = __webpack_public_path__ + "static/media/xlsx.d9feca4a.svg";